import { ContainerStatus } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

const containerResultFields = {
  id: true,
  status: true,
  containerNumber: true,
  sealNumber: true,
  bookingId: true,
  containerTypeId: true,
  loadId: true,
  facilityId: true,
  pickedUpAt: true,
  arrivedAtFacilityAt: true,
  loadedAt: true,
  departedFacilityAt: true,
  returnedToPortAt: true,
  shippedAt: true,
} as const;

export const containerPickupAtom = createMutationAtomFactory(
  'trade.containerPickup',
  (params: { id: string; containerNumber?: string | null }) => ({
    tradeContainerPickup: {
      __args: {
        id: params.id,
        containerNumber: params.containerNumber,
      },
      ...containerResultFields,
    },
  }),
);

export const containerArriveAtFacilityAtom = createMutationAtomFactory(
  'trade.containerArriveAtFacility',
  (params: {
    id: string;
    facilityId: string;
    containerNumber?: string | null;
  }) => ({
    tradeContainerArriveAtFacility: {
      __args: {
        id: params.id,
        facilityId: params.facilityId,
        containerNumber: params.containerNumber,
      },
      ...containerResultFields,
    },
  }),
);

export const containerLoadAtom = createMutationAtomFactory(
  'trade.containerLoad',
  (params: { id: string; loadId: string; sealNumber?: string | null }) => ({
    tradeContainerLoad: {
      __args: {
        id: params.id,
        loadId: params.loadId,
        sealNumber: params.sealNumber,
      },
      ...containerResultFields,
    },
  }),
);

export const containerDepartFacilityAtom = createMutationAtomFactory(
  'trade.containerDepartFacility',
  (params: { id: string }) => ({
    tradeContainerDepartFacility: {
      __args: {
        id: params.id,
      },
      ...containerResultFields,
    },
  }),
);

export const containerReturnToPortAtom = createMutationAtomFactory(
  'trade.containerReturnToPort',
  (params: { id: string }) => ({
    tradeContainerReturnToPort: {
      __args: {
        id: params.id,
      },
      ...containerResultFields,
    },
  }),
);

export const containerShipAtom = createMutationAtomFactory(
  'trade.containerShip',
  (params: { id: string }) => ({
    tradeContainerShip: {
      __args: {
        id: params.id,
      },
      ...containerResultFields,
    },
  }),
);

export const containerVoidAtom = createMutationAtomFactory(
  'trade.containerVoid',
  (params: { id: string }) => ({
    tradeContainerVoid: {
      __args: {
        id: params.id,
      },
    },
  }),
);

export const containerRevertStatusAtom = createMutationAtomFactory(
  'trade.containerRevertStatus',
  (params: { id: string; targetStatus: ContainerStatus }) => ({
    tradeContainerRevertStatus: {
      __args: {
        id: params.id,
        targetStatus: params.targetStatus,
      },
      ...containerResultFields,
    },
  }),
);

export const containerUnloadAtom = createMutationAtomFactory(
  'trade.containerUnload',
  (params: { id: string }) => ({
    tradeContainerUnload: {
      __args: {
        id: params.id,
      },
      ...containerResultFields,
    },
  }),
);

export const containerRollAtom = createMutationAtomFactory(
  'trade.containerRoll',
  (params: { id: string; newBookingId: string }) => ({
    tradeContainerRoll: {
      __args: {
        id: params.id,
        newBookingId: params.newBookingId,
      },
      ...containerResultFields,
    },
  }),
);
